import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const policySchema = z.object({
  type: z.string(),
});

export const Route = createFileRoute("/$lang/policy")({
  component: React.lazy(() =>
    import("@/pages/information/policy/policy").then((mod) => ({
      default: mod.PolicyPage,
    })),
  ),
  validateSearch: (search) => policySchema.parse(search),
});
